module.exports = __webpack_public_path__ + "media/components/wind-icon/static/NW@2x-1c7de7ae36367506e6209d52252e5bf7.png";